import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';

export const authExpiredInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);
  return next(req).pipe(
    catchError((error: unknown) => {
      if (error instanceof HttpErrorResponse && error.status === 401 && localStorage.getItem('medicareleeUser')) {
        localStorage.removeItem('medicareleeUser');
        void router.navigateByUrl('/');
        window.location.reload();
      }
      return throwError(() => error);
    })
  );
};
